export default "__VITE_PUBLIC_ASSET__885c29f5__"